import { cn } from '@/lib/utils'

/**
 * The app mark — the same artwork as the favicon and installed icon.
 *
 * Inline SVG rather than an <img>: it stays crisp at any size, needs no
 * network request, and cannot flash in late on first paint. The colours are
 * fixed rather than themed, because this is a logo — it reads as itself on a
 * light or dark surface.
 *
 * Source of truth for the shapes is design/icon.svg; keep the two in step.
 */
const SIZES = {
  sm: 'h-8 w-8',
  md: 'h-9 w-9',
  lg: 'h-12 w-12',
  // Onboarding only. A prompt asking somebody to change their home screen has
  // to look like it means it; 48px read as a favicon that had wandered in.
  xl: 'h-20 w-20',
} as const

export function BrandMark({
  size = 'md',
  className,
  title = 'MDV Services',
}: {
  size?: keyof typeof SIZES
  className?: string
  title?: string
}) {
  return (
    <svg
      viewBox="0 0 512 512"
      className={cn('shrink-0', SIZES[size], className)}
      role="img"
      aria-label={title}
    >
      <rect width="512" height="512" rx="112" fill="#09090b" />

      {/*
        Same transform as design/icon.svg: the mark scaled to 75% of the tile
        and centred on its own bounding box (259.2, 262). Without it this
        drifts visibly smaller than the installed app icon beside it.
      */}
      <g transform="translate(256 256) scale(1.18) translate(-259.2 -262)">
        {/* Three rules of a running order, the first one live. */}
        <rect x="96" y="136" width="192" height="40" rx="20" fill="#4ade80" />
        <rect x="96" y="224" width="192" height="40" rx="20" fill="#f4f4f5" />
        <rect x="96" y="312" width="192" height="40" rx="20" fill="#f4f4f5" />

        {/* Note head and stem. */}
        <ellipse cx="360" cy="344" rx="56" ry="44" fill="#4ade80" />
        <rect x="400" y="144" width="22.4" height="200" rx="11.2" fill="#4ade80" />
      </g>
    </svg>
  )
}
